// src/pages/DownloadPage.js
import React, { useEffect, useState, useRef } from 'react';
import config from '../config/config';

const orbitron = "'Orbitron', sans-serif";

const GALAXY_BG = `
    linear-gradient(rgba(0,0,0,0.88), rgba(0,0,0,0.92)),
    url('https://images.unsplash.com/photo-1462331940025-496dfbfc7564?w=1920&q=80') center/cover no-repeat fixed
`;

const DownloadPage = () => {
    const [apkVersion, setApkVersion] = useState(null);
    const [downloading, setDownloading] = useState(false);
    const [done, setDone] = useState(false);
    const starsRef = useRef(null);

    //https://canal-fr.km-bizz.com/app/version/latest

    useEffect(() => {
        fetch(`${config.host}app/version/latest`)
            .then(r => r.json())
            .then(d => setApkVersion(d))
            .catch(() => {});
    }, []);

    useEffect(() => {
        if (!starsRef.current) return;
        const container = starsRef.current;
        container.innerHTML = '';
        for (let i = 0; i < 80; i++) {
            const star = document.createElement('div');
            const size = Math.random() * 2 + 1;
            const duration = 2 + Math.random() * 4;
            const delay = Math.random() * 4;
            star.style.cssText = `
                position:absolute;border-radius:50%;background:#fff;
                width:${size}px;height:${size}px;
                top:${Math.random() * 100}%;left:${Math.random() * 100}%;
                animation:twinkle ${duration}s ease-in-out ${delay}s infinite alternate;
            `;
            container.appendChild(star);
        }
    }, []);

    const handleDownload = () => {
        setDownloading(true);
        setTimeout(() => {
            window.open(`${config.host}app/download`, '_blank');
            setDownloading(false);
            setDone(true);
        }, 1800);
    };

    const QRPattern = [
        1,1,1,1,1,1,1,
        1,0,0,0,0,0,1,
        1,0,1,0,1,0,1,
        1,0,0,1,0,0,1,
        1,0,1,0,1,0,1,
        1,0,0,0,0,0,1,
        1,1,1,1,1,1,1,
    ];
    const formatBytes = (bytes) => {
        if (bytes === 0) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${units[i]}`;
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;600;700;900&display=swap');
                @keyframes twinkle { 0%{opacity:.1} 100%{opacity:.8} }
                @keyframes pulse   { 0%,100%{transform:scale(1);opacity:1} 50%{transform:scale(1.4);opacity:.6} }
                @keyframes bounce  { 0%{transform:translateY(0)} 100%{transform:translateY(-4px)} }
                @keyframes shimmer { 0%{background-position:-200% center} 100%{background-position:200% center} }
                .dl-btn-hover:hover {
                    background: linear-gradient(135deg,#1976d2,#1565c0) !important;
                    border-color: #42a5f5 !important;
                    box-shadow: 0 0 32px rgba(21,101,192,0.65) !important;
                }
            `}</style>

            <div style={{
                minHeight: '100vh',
                background: GALAXY_BG,
                fontFamily: orbitron,
                position: 'relative',
                overflowX: 'hidden',
                paddingBottom: 64,
            }}>
                {/* Stars */}
                <div ref={starsRef} style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0 }} />

                {/* Grid overlay */}
                <div style={{
                    position: 'fixed', inset: 0, zIndex: 0, pointerEvents: 'none',
                    backgroundImage: `linear-gradient(rgba(21,101,192,0.07) 1px,transparent 1px),linear-gradient(90deg,rgba(21,101,192,0.07) 1px,transparent 1px)`,
                    backgroundSize: '48px 48px',
                }} />

                {/* Blobs */}
                <div style={{ position:'fixed', width:500, height:500, borderRadius:'50%', background:'rgba(21,101,192,0.12)', top:-150, left:-150, filter:'blur(80px)', pointerEvents:'none', zIndex:0 }} />
                <div style={{ position:'fixed', width:400, height:400, borderRadius:'50%', background:'rgba(255,215,0,0.05)', bottom:-100, right:-100, filter:'blur(80px)', pointerEvents:'none', zIndex:0 }} />

                {/* ── NAVBAR ── */}
                <nav style={{
                    position: 'relative', zIndex: 10,
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    padding: '18px 40px',
                    borderBottom: '1px solid rgba(21,101,192,0.2)',
                    background: 'rgba(3,3,15,0.75)',
                    backdropFilter: 'blur(12px)',
                }}>
                    <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                        <div style={{
                            width:32, height:32, background:'#1565c0', borderRadius:6,
                            display:'flex', alignItems:'center', justifyContent:'center',
                            fontSize:13, color:'#fff', fontWeight:900, letterSpacing:1,
                        }}>KM</div>
                        <span style={{ fontSize:'.7rem', fontWeight:700, color:'#fff', letterSpacing:3 }}>KM-BIZZ</span>
                    </div>
                    <div style={{
                        fontSize:'.5rem', color:'#1e88e5', letterSpacing:2,
                        border:'1px solid rgba(30,136,229,0.3)', padding:'3px 10px', borderRadius:4,
                    }}>BigG Stream + · STREAMING</div>
                </nav>

                {/* ── HERO ── */}
                <div style={{ position:'relative', zIndex:5, textAlign:'center', padding:'64px 24px 40px' }}>
                    {/* Eyebrow */}
                    <div style={{
                        display:'inline-flex', alignItems:'center', gap:8,
                        border:'1px solid rgba(21,101,192,0.35)', borderRadius:20,
                        padding:'6px 16px', marginBottom:28,
                        background:'rgba(21,101,192,0.08)',
                    }}>
                        <div style={{
                            width:6, height:6, borderRadius:'50%', background:'#1e88e5',
                            animation:'pulse 2s ease-in-out infinite',
                        }} />
                        <span style={{ fontSize:'.55rem', color:'#1e88e5', letterSpacing:3 }}>
                            LATEST RELEASE AVAILABLE
                        </span>
                    </div>

                    <h1 style={{
                        fontSize: 'clamp(1.5rem,4vw,2.6rem)',
                        fontWeight: 900, color: '#fff',
                        letterSpacing: 4, lineHeight: 1.2,
                        textTransform: 'uppercase', marginBottom: 16,
                    }}>
                        Download <span style={{ color:'#1e88e5' }}>bigG-Stream +</span><br />Android App
                    </h1>
                    <p style={{
                        fontSize: '.65rem', color: 'rgba(255,255,255,0.4)',
                        letterSpacing: 2, maxWidth: 480, margin: '0 auto',
                        lineHeight: 1.9,
                    }}>
                        Stream live TV, movies and series from bigG-Stream directly on your Android TV or device
                    </p>
                </div>

                {/* ── MAIN CARD ── */}
                <div style={{ position:'relative', zIndex:5, maxWidth:860, margin:'0 auto', padding:'0 24px' }}>
                    <div style={{
                        background: 'rgba(8,8,24,0.92)',
                        border: '1px solid rgba(21,101,192,0.4)',
                        borderRadius: 20, overflow: 'hidden',
                        backdropFilter: 'blur(16px)',
                    }}>
                        {/* Top shimmer line */}
                        <div style={{
                            height: 3,
                            background: 'linear-gradient(90deg,transparent,#1e88e5 40%,#FFD700 60%,transparent)',
                        }} />

                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))',
                        }}>
                            {/* ── LEFT PANEL ── */}
                            <div style={{ padding:36, borderRight:'1px solid rgba(21,101,192,0.15)' }}>
                                {/* App icon + name */}
                                <div style={{ display:'flex', alignItems:'center', gap:16, marginBottom:28 }}>
                                    <div style={{
                                        width:64, height:64,
                                        background:'linear-gradient(135deg,#0d47a1,#1565c0)',
                                        borderRadius:16, border:'1px solid #1e88e5',
                                        display:'flex', alignItems:'center', justifyContent:'center',
                                        fontSize:28, flexShrink:0,
                                    }}>📺</div>
                                    <div>
                                        <div style={{ fontSize:'.9rem', fontWeight:700, color:'#fff', letterSpacing:2, marginBottom:4 }}>BigG-Stream+ TV</div>
                                        <div style={{ fontSize:'.55rem', color:'#1e88e5', letterSpacing:2 }}>BY KM-BIZZ.COM</div>
                                    </div>
                                </div>

                                {/* Version badges */}
                                <div style={{ display:'flex', gap:10, marginBottom:24, flexWrap:'wrap' }}>
                                    <div style={{
                                        background:'rgba(21,101,192,0.15)',
                                        border:'1px solid rgba(21,101,192,0.4)',
                                        borderRadius:6, padding:'5px 14px',
                                    }}>
                                        <div style={{ fontSize:'.45rem', color:'rgba(255,255,255,0.35)', letterSpacing:2 }}>VERSION</div>
                                        <div style={{ fontSize:'.65rem', color:'#fff', fontWeight:700, letterSpacing:1 }}>
                                            v{apkVersion?.version || '—'}
                                        </div>
                                    </div>
                                    <div style={{
                                        background:'rgba(255,215,0,0.07)',
                                        border:'1px solid rgba(255,215,0,0.35)',
                                        borderRadius:6, padding:'5px 14px',
                                    }}>
                                        <div style={{ fontSize:'.45rem', color:'rgba(255,255,255,0.35)', letterSpacing:2 }}>STATUS</div>
                                        <div style={{ fontSize:'.65rem', color:'#FFD700', fontWeight:700, letterSpacing:1 }}>LATEST</div>
                                    </div>
                                </div>

                                {/* Stats */}
                                <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:10, marginBottom:28 }}>
                                    {[
                                        { val:` ${formatBytes(apkVersion?.fileBytes)}`, lbl:'SIZE' },
                                        { val:'5.0+',  lbl:'ANDROID' },
                                        { val:'ARM64', lbl:'ARCH' },
                                    ].map(s => (
                                        <div key={s.lbl} style={{
                                            background:'rgba(21,101,192,0.08)',
                                            border:'1px solid rgba(21,101,192,0.2)',
                                            borderRadius:8, padding:10, textAlign:'center',
                                        }}>
                                            <div style={{ fontSize:'.7rem', fontWeight:700, color:'#fff', letterSpacing:1 }}>{s.val}</div>
                                            <div style={{ fontSize:'.42rem', color:'rgba(255,255,255,0.3)', letterSpacing:1.5, marginTop:3 }}>{s.lbl}</div>
                                        </div>
                                    ))}
                                </div>

                                {/* Features */}
                                <div style={{ display:'flex', flexDirection:'column', gap:9 }}>
                                    {[
                                        'Live TV & DASH streaming',
                                        'Widevine DRM protected',
                                        'Amazon Fire TV optimized',
                                        'Multi-environment support',
                                        'Auto update detection',
                                    ].map(f => (
                                        <div key={f} style={{ display:'flex', alignItems:'center', gap:10 }}>
                                            <div style={{ width:6, height:6, borderRadius:'50%', background:'#1e88e5', flexShrink:0 }} />
                                            <span style={{ fontSize:'.55rem', color:'rgba(255,255,255,0.55)', letterSpacing:1 }}>{f}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* ── RIGHT PANEL ── */}
                            <div style={{ padding:36, display:'flex', flexDirection:'column', gap:20 }}>
                                {/* QR Code */}
                                <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:12 }}>
                                    <div style={{
                                        width:130, height:130,
                                        background:'rgba(21,101,192,0.08)',
                                        border:'1px solid rgba(21,101,192,0.3)',
                                        borderRadius:12,
                                        display:'grid', gridTemplateColumns:'repeat(7,1fr)',
                                        gap:2, padding:12,
                                    }}>
                                        {QRPattern.map((v, i) => (
                                            <div key={i} style={{
                                                background: v ? '#1e88e5' : 'rgba(21,101,192,0.08)',
                                                borderRadius: v ? 2 : 0,
                                                aspectRatio: '1',
                                            }} />
                                        ))}
                                    </div>
                                    <span style={{ fontSize:'.5rem', color:'rgba(255,255,255,0.3)', letterSpacing:2 }}>
                                        SCAN TO DOWNLOAD
                                    </span>
                                </div>

                                {/* OR divider */}
                                <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                                    <div style={{ flex:1, height:1, background:'rgba(21,101,192,0.2)' }} />
                                    <span style={{ fontSize:'.5rem', color:'rgba(255,255,255,0.2)', letterSpacing:2 }}>OR</span>
                                    <div style={{ flex:1, height:1, background:'rgba(21,101,192,0.2)' }} />
                                </div>

                                {/* Download button */}
                                <button
                                    className="dl-btn-hover"
                                    onClick={handleDownload}
                                    disabled={downloading}
                                    style={{
                                        width:'100%', border:'none', cursor: done ? 'default' : 'pointer',
                                        background: done
                                            ? 'linear-gradient(135deg,#0a5c2a,#0d7a35)'
                                            : 'linear-gradient(135deg,#1565c0,#0d47a1)',
                                        borderRadius:10, padding:'14px 0',
                                        display:'flex', alignItems:'center', justifyContent:'center', gap:10,
                                        transition:'all .25s',
                                        boxShadow:'0 0 20px rgba(21,101,192,0.4)',
                                        outline:'1px solid ' + (done ? '#2e7d32' : '#1e88e5'),
                                        opacity: downloading ? .7 : 1,
                                    }}
                                >
                                    <span style={{ fontSize:16, animation: done ? 'none' : 'bounce .8s ease-in-out infinite alternate' }}>
                                        {done ? '✅' : downloading ? '⏳' : '⬇'}
                                    </span>
                                    <div>
                                        <div style={{ fontSize:'.65rem', fontWeight:700, color:'#fff', letterSpacing:3 }}>
                                            {done ? 'DOWNLOAD STARTED' : downloading ? 'PREPARING...' : 'DOWNLOAD APK'}
                                        </div>
                                        <div style={{ fontSize:'.45rem', color:'rgba(255,255,255,0.45)', letterSpacing:1, marginTop:2 }}>
                                            {done
                                                ? 'OPEN THE APK TO INSTALL'
                                                : `VERSION ${apkVersion?.version || '—'} · FREE`}
                                        </div>
                                    </div>
                                </button>

                                {/* Install steps */}
                                <div style={{
                                    background:'rgba(21,101,192,0.05)',
                                    border:'1px solid rgba(21,101,192,0.15)',
                                    borderRadius:8, padding:14,
                                }}>
                                    <div style={{ fontSize:'.5rem', color:'#1e88e5', letterSpacing:2, marginBottom:10 }}>
                                        HOW TO INSTALL
                                    </div>
                                    {[
                                        'Download the APK file to your device',
                                        'Enable "Install from unknown sources" in Settings',
                                        'Open the APK and follow the install prompts',
                                        'Launch bigG-stream+ and sign in to start streaming',
                                    ].map((step, i) => (
                                        <div key={i} style={{ display:'flex', alignItems:'flex-start', gap:8, marginBottom: i < 3 ? 8 : 0 }}>
                                            <div style={{
                                                width:18, height:18, borderRadius:'50%', flexShrink:0,
                                                background:'rgba(21,101,192,0.3)',
                                                border:'1px solid rgba(21,101,192,0.5)',
                                                display:'flex', alignItems:'center', justifyContent:'center',
                                                fontSize:'.42rem', color:'#1e88e5', fontWeight:700,
                                            }}>{i + 1}</div>
                                            <span style={{ fontSize:'.5rem', color:'rgba(255,255,255,0.45)', letterSpacing:.8, lineHeight:1.6 }}>
                                                {step}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ── RELEASE NOTES ── */}
                {apkVersion?.releaseNotes && (
                    <div style={{ position:'relative', zIndex:5, maxWidth:860, margin:'28px auto 0', padding:'0 24px' }}>
                        <div style={{
                            background:'rgba(8,8,24,0.85)',
                            border:'1px solid rgba(21,101,192,0.25)',
                            borderRadius:16, padding:'24px 28px',
                            display:'flex', gap:18, alignItems:'flex-start',
                        }}>
                            <div style={{
                                width:40, height:40, flexShrink:0,
                                background:'rgba(255,215,0,0.08)',
                                border:'1px solid rgba(255,215,0,0.25)',
                                borderRadius:8, display:'flex', alignItems:'center', justifyContent:'center',
                                fontSize:18,
                            }}>📋</div>
                            <div style={{ flex:1 }}>
                                <div style={{ fontSize:'.6rem', fontWeight:700, color:'#FFD700', letterSpacing:3, marginBottom:10 }}>
                                    RELEASE NOTES
                                </div>
                                <div style={{
                                    fontSize:'.55rem', color:'rgba(255,255,255,0.45)',
                                    letterSpacing:.8, lineHeight:1.9,
                                    borderLeft:'2px solid rgba(21,101,192,0.4)', paddingLeft:12,
                                }}>
                                    {apkVersion.releaseNotes}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* ── COMPATIBILITY ── */}
                <div style={{ position:'relative', zIndex:5, maxWidth:860, margin:'20px auto 0', padding:'0 24px' }}>
                    <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))', gap:14 }}>
                        {[
                            { icon:'📱', lbl:'PLATFORM',  val:'Android 5.0+' },
                            { icon:'📺', lbl:'TV SUPPORT', val:'Fire TV / Android TV' },
                            { icon:'🔒', lbl:'SECURITY',  val:'Widevine L1 / L3' },
                        ].map(c => (
                            <div key={c.lbl} style={{
                                background:'rgba(8,8,24,0.8)',
                                border:'1px solid rgba(21,101,192,0.2)',
                                borderRadius:12, padding:'16px 18px',
                                display:'flex', alignItems:'center', gap:12,
                            }}>
                                <span style={{ fontSize:20 }}>{c.icon}</span>
                                <div>
                                    <div style={{ fontSize:'.45rem', color:'rgba(255,255,255,0.3)', letterSpacing:2 }}>{c.lbl}</div>
                                    <div style={{ fontSize:'.6rem', color:'#fff', fontWeight:600, letterSpacing:1, marginTop:3 }}>{c.val}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* ── FOOTER ── */}
                <div style={{ position:'relative', zIndex:5, textAlign:'center', marginTop:48, padding:'0 24px' }}>
                    <div style={{ fontSize:'.5rem', color:'rgba(255,255,255,0.15)', letterSpacing:1.5 }}>
                        © 2026 KM-BIZZ · canal-fr.km-bizz.com · All rights reserved
                    </div>
                </div>
            </div>
        </>
    );
};

export default DownloadPage;